import BarekamButton, {HeaderButtons} from '../../../components/button';
import {BarekamIcon, IconVariants} from "../../../components/icon/barekam-icon";
import {useAppDispatch, useAppSelector} from "../../../../redux/store";
import {changeSidebarIsOpen} from '../../../../redux/slices/sidebar.slice';

const BurgerButton = () => {
    const {isOpen} = useAppSelector(state => state.sidebarReducer);
    const dispatch = useAppDispatch();

    const toggleSidebar = () => {
        dispatch(changeSidebarIsOpen(!isOpen));
    };

    return (
        <BarekamButton type={HeaderButtons.SIMPLE} onClick={() => toggleSidebar()}>
            <BarekamIcon variant={IconVariants.burger}/>
        </BarekamButton>
    );
};

export default BurgerButton;
